<template>
    <div class="client">
        <router-view></router-view>
        <div class="updiv">
            <el-row>
                <el-col :span="12"> 
                    <el-button  @click="left"  class="hbt" ></el-button>
                </el-col>
                <el-col :span="12" style="text-align:right">       
                    <el-button  @click="right"  class="hbt" ></el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {uploadLogs} from '@/api/user'
export default {
    name: "client",
    data() {
        return {
            leftTimeOut : undefined,
            leftClick : 0,
		    rightClick : 0,
            loadingInstance: null,
            loadingTxt: '设备初始化,请稍候...',
            //所有组件状态列表
            modulesStatus: [],
            //所有组件列表
            g_modules: [],
            sharedState: this.myStore.state
        }
    },
    created() {
        this.showLoad();
        this.initDevice();
    },
    methods: {
        showLoad() {
            const options = {
                lock: true,
                text: this.loadingTxt,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            };
            this.loadingInstance = this.$loading(options);
        },
        async initDevice() {
            this.g_modules.push(this.sys);
            this.g_modules.push(this.siu);
            this.g_modules.push(this.ptr);
            this.g_modules.push(this.ist);
            this.g_modules.push(this.cam);
            console.warn("=======================设备组件================");
            console.log(this.g_modules);
            for (let i = 0; i < this.g_modules.length; i++) {
                await this.g_modules[i].on("onStatusChanged", this.onStatusChangedComplete);
            }
            for (let i = 0; i < this.g_modules.length; i++) {
                await this.openDev(this.g_modules[i]);
            }
            for (let i = 0; i < this.g_modules.length; i++) {
                await this.resetDev(this.g_modules[i]);
            }
            if (this.loadingTxt.indexOf("失败") > 0) {//初始化失败
                this.updateModuleStatus();
                return ;
            }
            this.loadingInstance.close();
            await this.getStatus(this.g_modules);
            this.$router.push({ path: this.sharedState.mainUrl })
            this.openSecondScreen()
        },
        // 打开副屏
        openSecondScreen(){
            const router = this.$router;
            const route = router.resolve({ path: '/video'});
            var features = 'left=190,top=180,width=1920,height=1080,alwaysRaised=yes,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no';
            Vue.prototype.videoWindow = window.open(route.href, 'newwindow','width=1920,height=1080,top=0,left=1920')
        },
        async openDev(g_module) {
            var param = {};
            if(g_module.config.device == 'IST') {
                param.scanner = true;
			    param.ist = true;
            }
            var result = await g_module.openDevice(param);
            console.info(JSON.stringify(result));
            if (result.result == 0) {
                console.info("打开" + g_module.config.devname + "成功");
                if (this.loadingTxt.indexOf("失败") < 0) {
                    this.loadingTxt="打开" + g_module.config.devname + "成功";
                    this.loadingInstance.setText(this.loadingTxt);
                }
            } else {
                console.error("打开" + g_module.config.devname + "发生错误:" + result.message);
                this.loadingTxt="打开" + g_module.config.devname + "失败";
                this.loadingInstance.setText(this.loadingTxt);
                let moduleStatus = {
                    "status" : -1,
                    "message" : "打开" + g_module.config.devname + "失败",
                    "status_code" : 7,
                    "status_message":"打开" + g_module.config.devname + "失败"
                };
                this.setModuleStatus(g_module, moduleStatus);
            }
        },
        async resetDev(g_module) {
            var result = await g_module.resetDevice();
            console.info(JSON.stringify(result));
            if (result.result == 0) {
                console.info("初始化" + g_module.config.devname + "成功");
                if (this.loadingTxt.indexOf("失败") < 0) {
                    this.loadingTxt="初始化" + g_module.config.devname + "成功";
                    this.loadingInstance.setText(this.loadingTxt);
                }
            } else {
                console.error("初始化" + g_module.config.devname + "发生错误:" + result.message);
                this.loadingTxt="初始化" + g_module.config.devname + "失败";
                this.loadingInstance.setText(this.loadingTxt);
                let moduleStatus = {
                    "status" : -1,
                    "message" : "初始化" + g_module.config.devname + "失败",
                    "status_code" : 7,
                    "status_message" : "初始化" + g_module.config.devname + "失败",
                };
                this.setModuleStatus(g_module, moduleStatus);
            }
        },
        //设置组件状态信息，信息以status_message为准
        setModuleStatus(g_module, moduleStatus) {
            var status = 0;
			if (moduleStatus.status === 0) {
				status = 1;
			} else if (moduleStatus.status > 0) {
				status = 2;
			} else if (moduleStatus.status < 0) {
				status = 3;
			}
			var module = {
                    "moduleId" : g_module.config.id,
                    "name" : g_module.config.devname,
					"service" : g_module.config.service,
					"status" : status,
                    "message" : moduleStatus.message != null ? moduleStatus.message : "",
                    "statusCode" : moduleStatus.status_code != null ? moduleStatus.status_code : "",
					"deviceMessage" : moduleStatus.status_message != null ? moduleStatus.status_message : "",
					"remark" : moduleStatus.device_info
			};
            //针对打印机或者其他特殊硬件处理
            let remark = module.remark;
            if((typeof remark !== "undefined") && (typeof remark !== "string")) {//不是字符串的转成字符串
                module.remark = JSON.stringify(remark);
            }
			this.modulesStatus.push(module);
        },
        async getStatus(g_modules) {
            this.modulesStatus = [];
			for(var i = 0;i < g_modules.length;i++){				
				var moduleStatus = await g_modules[i].getStatus();
				console.info("moduleStatus============" + JSON.stringify(moduleStatus));	
				this.setModuleStatus(g_modules[i],moduleStatus);
			}
        },
        left(){
            if(!this.leftTimeOut){
                this.leftTimeOut=setTimeout(this.clearTimeout(),5000);
            }
            if(this.leftClick<3){
                this.leftClick+=1;
                console.info(this.leftClick);
            }
        },
        right(){
            if(this.leftClick==3){
                this.rightClick+=1;
                console.info(this.rightClick);
            }
            if(this.rightClick==3&&this.leftClick==3){
                this.clearTimeout();
                let url = this.sharedState.manageUrl + '/inputName';
                if (this.$route.path !== url) {
                    if(this.$route.path !== '/boaccount/client/main/login'){
                        this.$store.dispatch('FedLogOut').then(() => {
                            this.$router.push(url);
                        })
                    }else {
                        this.$router.push(url);
                    }
                    
                }
            }
        },
        clearTimeout(){
            clearTimeout(this.leftTimeOut);
            this.leftTimeOut = undefined;
            this.leftClick = 0;
            this.rightClick = 0;
        },
        servicePage() {
            this.$router.push({ path: '/boaccount/servicePage' });
        }
    }
}
</script>

<style scoped>
    @import "~@/assets/css/client.css";

    .client,.el-container.is-vertical {
        height: 100%;
    } 
    .updiv {
        position: absolute;
        width: 100%;
        z-index: 2000000;
    }
    .hbt {        
        background: transparent;
        border: none;
        width: 3rem;
        height: 3rem;
        z-index: 20000;
    }
</style>